import AcServices from "../modules/ac-services";
export var initAcServices = function () {
    if (!window.AC_SERVICES) {
        window.AC_SERVICES = new AcServices();
    }
    return window.AC_SERVICES;
};
